import React, {useState} from 'react'
import {Modal, Button, Form, InputNumber, Radio, Space} from "antd";
import {A} from "hookrouter";
import {CopyOutlined} from '@ant-design/icons'
import {successN, errorN} from "../../general";

// Same formula as Windows frmCalulator: tax and service charge are compounded.
function factor(tax, sc) {
    let tx = (tax || 0) / 100;
    let s = (sc || 0) / 100;
    return 1 + tx + s + (tx * s);
}

function round2(v) {
    return Math.round((v + Number.EPSILON) * 100) / 100;
}

function TaxCalculator(props) {
    const [visible, setVisible] = useState(false);
    const [type, setType] = useState(0);
    const [form] = Form.useForm();

    // from = 'amt' or 'amtTax': the box the user typed in
    function calculate(from) {
        const v = form.getFieldsValue(true);
        let f = factor(v.tax, v.sc);

        if (from === 'amtTax')
        {
            form.setFieldsValue({amt: round2((v.amtTax || 0) / f)});
        }
        else
        {
            form.setFieldsValue({amtTax: round2((v.amt || 0) * f)});
        }
    }

    function onTypeChange(e) {
        setType(e.target.value);
        // Before tax: Amount drives Amount with Tax. After tax: the reverse.
        calculate(e.target.value === 0 ? 'amt' : 'amtTax');
    }

    async function copy(name) {
        const v = form.getFieldsValue(true);
        let txt = (v[name] || 0).toFixed(2);

        try
        {
            await navigator.clipboard.writeText(txt);
            successN(`Copied ${txt}`);
        }
        catch (err)
        {
            errorN(`Copy failed: ${err}`);
        }
    }

    function close() {
        setVisible(false);
        form.resetFields();
        setType(0);
    }

    const num = {style: {width: 180}, min: 0, precision: 2};

    return (
        <>

            <A href={''} onClick={() => {setVisible(true);}}>Tax Calculator</A>

            <Modal
                visible={visible}
                title='Tax Calculator'
                onCancel={close}
                footer={[
                    <Button key="close" type="primary" onClick={close}>Close</Button>
                ]}
            >
                <Form form={form} layout="horizontal" labelCol={{span: 10}} wrapperCol={{span: 14}}>

                    <Form.Item label="Type">
                        <Radio.Group value={type} onChange={onTypeChange}>
                            <Radio value={0}>Before Tax</Radio>
                            <Radio value={1}>After Tax</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="Tax (%)" name="tax">
                        <InputNumber {...num} onChange={() => setTimeout(() => calculate(type === 0 ? 'amt' : 'amtTax'))} />
                    </Form.Item>

                    <Form.Item label="Service Charge (%)" name="sc">
                        <InputNumber {...num} onChange={() => setTimeout(() => calculate(type === 0 ? 'amt' : 'amtTax'))} />
                    </Form.Item>

                    <Form.Item label="Amount">
                        <Space>
                            <Form.Item name="amt" noStyle>
                                <InputNumber {...num} onChange={() => setTimeout(() => calculate('amt'))} />
                            </Form.Item>
                            <Button icon={<CopyOutlined />} onClick={() => copy('amt')} />
                        </Space>
                    </Form.Item>

                    <Form.Item label="Amount with Tax">
                        <Space>
                            <Form.Item name="amtTax" noStyle>
                                <InputNumber {...num} onChange={() => setTimeout(() => calculate('amtTax'))} />
                            </Form.Item>
                            <Button icon={<CopyOutlined />} onClick={() => copy('amtTax')} />
                        </Space>
                    </Form.Item>

                </Form>
            </Modal>

        </>
    )
}

export default TaxCalculator
